import { useState } from "react";

/** Opaque player-only cover. Progress describes completed loader work, never
 * a made-up timer; only the renderer's readiness signal releases the scene. */
export function PlayerLoadingScreen({
  ready = false,
  progress = 0,
}: {
  ready?: boolean;
  progress?: number;
}) {
  const [logoFailed, setLogoFailed] = useState(false);
  const complete = Math.max(
    0,
    Math.min(1, Number.isFinite(progress) ? progress : 0),
  );
  return (
    <div className="player-loading" data-ready={ready} aria-hidden={ready}>
      <div className="player-loading__content">
        {logoFailed ? (
          <strong className="player-loading__wordmark">TILT RACING</strong>
        ) : (
          <img
            className="player-loading__logo"
            alt="Tilt Racing"
            width="240"
            height="145"
            src="/app/static/themes/monkeytilt/tilt-racing-logo.png"
            onError={() => setLogoFailed(true)}
          />
        )}
        <div
          className="player-loading__track"
          aria-hidden="true"
          data-indeterminate={complete === 0}
        >
          <span
            style={{ width: `${Math.max(6, Math.min(95, complete * 95))}%` }}
          />
        </div>
        <div
          className="player-loading__copy"
          role={ready ? undefined : "status"}
          aria-live="polite"
        >
          <strong>
            {complete >= 1 ? "Preparing the scene" : "Loading the race"}
          </strong>
          <span>Getting the track and horses ready.</span>
        </div>
      </div>
    </div>
  );
}
